import { nanoid } from 'nanoid'
import { fireApiGet } from './api'

export const conciergeFireService = {
  getFireToggle(tenantId: string) {
    return fireApiGet(`api/concierge/v1/public/tenant/${tenantId}/migration/settings`, {
      headers: {
        'x-request-id': nanoid(),
        'x-caller-ref': `guest/${nanoid()}`,
      },
    })
      .json<{ useFire: boolean }>()
      .then(({ useFire }) => useFire)
  },
}
